import React from "react";

const InfoPanelsComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default InfoPanelsComponent;
